import { ComponentProps } from "react";
import UpdatedTime from "@atoms/Time/UpdatedTime";
import Card from "@particles/card/Card";
import { cn } from "@util/helpers";

export type NewsletterPostProps = {
  className?: string;
} & Pick<
  ComponentProps<typeof Card>,
  "title" | "link" | "updatedTime" | "displayPaywall"
>;

export default function NewsletterPost({
  title,
  link,
  updatedTime,
  className,
  displayPaywall = false,
}: NewsletterPostProps): React.ReactElement {
  return (
    <>
      <div
        data-testid="newsletter-post"
        className={cn(className, "pb-3 lg:pt-3")}
      >
        <div className="flex flex-row justify-between">
          <div className="flex w-full flex-col lg:w-2/3 lg:flex-row">
            <div>
              <div className="block font-poppins text-xs font-normal text-gray-550 lg:hidden">
                {updatedTime ? (
                  <UpdatedTime
                    updated={updatedTime}
                    className="block font-poppins text-xs font-normal capitalize text-gray-550 lg:hidden"
                    dateFormat="MMMM DD, YYYY"
                  />
                ) : null}
              </div>

              <p
                className={cn("mb-0 pr-2 font-lct text-xl font-bold", {
                  "pb-4": !displayPaywall,
                })}
              >
                <a
                  href={link}
                  target="_blank"
                  className="hover:underline"
                  rel="noreferrer"
                >
                  {title}
                </a>

                {displayPaywall ? (
                  <span className="relative hidden pl-4 text-base leading-[.3] text-orange-300 before:content-['\25CF'] lg:inline lg:pl-4">
                    <span className="font-public-sans text-4xs font-normal uppercase text-gray-900">
                      Subscribers
                    </span>
                  </span>
                ) : null}
              </p>

              {displayPaywall ? (
                <span className="relative block pb-4 pt-3 text-xs leading-[.3] text-orange-300 before:content-['\25CF'] lg:hidden">
                  <span className="font-poppins text-4xs font-normal uppercase text-gray-900">
                    Subscribers
                  </span>
                </span>
              ) : null}
            </div>
          </div>

          {updatedTime ? (
            <UpdatedTime
              updated={updatedTime}
              className="hidden font-poppins text-xs font-normal capitalize text-gray-550 lg:block"
              dateFormat="MMMM DD, YYYY"
            />
          ) : null}
        </div>
      </div>
    </>
  );
}
